import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { getUiInterface } from "../../../locales/translationUtils";
import getFilterLabels from "../../../types/filterLabels";

interface FilterProps {
  filters: Record<string, string>;
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
  /** Estado do checkbox "somente PU a partir de 01/01/2021". */
  filtrarPuApartir2021: boolean;
  onToggleFiltrarPuApartir2021: (checked: boolean) => void;
}

const Filter: React.FC<FilterProps> = ({
  filters,
  onFilterChange,
  onSearch,
  filtrarPuApartir2021,
  onToggleFiltrarPuApartir2021,
}) => {
  const filterLabels = getFilterLabels();
  const camposOcultos = ["pageNum", "quantityPerPage", "paginacao", "sort", "order", "puInicio", "puFim"];
  return (
    <Form className="mb-2">
      <Row className="mb-3">
        {Object.entries(filters)
        .filter(([key]) => !camposOcultos.includes(key))
        .map(([key, value]) => (
          <Col md={2} key={key}>
            <Form.Group controlId={`filter-${key}`} className="mt-2">
              <Form.Label>
                {filterLabels[key] ||
                  key.charAt(0).toUpperCase() + key.slice(1)}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={key}
                name={key}
                value={value}
                onChange={onFilterChange}
              />
            </Form.Group>
          </Col>
        ))}
      </Row>
      <Row>
        <Col xs="auto">
          <div className="d-flex align-items-center" style={{ gap: '12px' }}>
            <Button variant="primary" onClick={onSearch}>
              {getUiInterface("search")}
            </Button>
            <Form.Check
              type="checkbox"
              id="filtro-pu-apartir-2021"
              label={getUiInterface('filterPuFrom2021')}
              checked={filtrarPuApartir2021}
              onChange={(e) => onToggleFiltrarPuApartir2021(e.target.checked)}
            />
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default Filter;
